import './loadingCard.scss';

import { ReactNode } from 'react';

import { LoadingCardProps } from './types/LoadingCardProps';

export const LoadingCard = ({ testId }: LoadingCardProps): ReactNode => {
  return (
    <li className="loading-card" data-testid={testId}>
      <div className="loading-card-image loading-card-shine" />
      <div className="loading-card-content">
        <div className="loading-card-line loading-card-shine" />
        <div className="loading-card-line loading-card-line-short loading-card-shine" />
      </div>
    </li>
  );
};
